import { createAsyncThunk } from '@reduxjs/toolkit';
import API from '../../../services/apiAxios';
import { TransactionHistoryQuery } from './Type';

const getTransactionList = createAsyncThunk(
  'getTransactionList',
  async (queryParams: TransactionHistoryQuery | { customApiUrl?: string; [key: string]: any }) => {
    let res;
    if (queryParams && 'customApiUrl' in queryParams && queryParams.customApiUrl) {
      const { customApiUrl, ...restParams } = queryParams;
      res = await API.get(customApiUrl, {
        params: Object.keys(restParams).length > 0 ? restParams : undefined,
      });
    } else {
      res = await API.get(`/payment/transaction/all`, { params: queryParams });
    }
    return res.data;
  },
);

const ExportTransactions = createAsyncThunk('WalletExport', async (queryParams: TransactionHistoryQuery) => {
  const res = await API.get(`/wallet/export?`, {
    params: { fromDate: queryParams.fromDate, toDate: queryParams.toDate },
  });
  window.open(res.data.data, '_blank');
  return {};
});

export { getTransactionList, ExportTransactions };
